import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_LOAD, IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { RedeemRulesSchema, RedemptionLevelResponse } from '../models/redeem-rules.model';
import { RedeemRulesSearchFacadeService } from './search.facade.service';

@Injectable({ providedIn: 'root' })
export class SearchRedeemRulesService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private searchFacade: RedeemRulesSearchFacadeService,
  ) {}

  schemas(): Observable<RedeemRulesSchema[]> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/loyalty/schemas';

    return this.http.get<RedeemRulesSchema[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  searchRedemptionLevels(): Observable<RedemptionLevelResponse> {
    const url =
      this.environmentFacadeService.getEnvironment() +
      '/rest/v1/loyalty/redemption-level?loyaltySchemaCode=' +
      this.searchFacade.selectedSchema;

    return this.http.get<RedemptionLevelResponse>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }
}
